import { AssetResource } from '@com/components/asset-dialog/type'

/**
 * 通过资产库的资源格式，转换成 PT 上传后的文件格式
 */
export default function useAssetToExchangeFile(assetRes: AssetResource) {
  return {
    url: assetRes.full_url,
    origin_name: `${assetRes.name}.${assetRes.format}`,
    file_path: '',
    md5: assetRes.fingerprint,
    res_id: assetRes.id,
    res_source: 'assets',
  }
}
